export default __webpack_public_path__ + "static/media/mot-safe-white.b2b45c2c.png";